import React from 'react';
import superagent from 'superagent';
import cookie from 'react-cookies';

import * as ApiUtils from '../CloudApi/ApiUtils.js';
import BigShipperWrapper from './BigShipperWrapper.jsx';

export default class BigShipperLogs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bigOrder: null
        };
    }

    render() {
        return (
            <BigShipperWrapper title="Coming soon!">
                <p>Coming soon!</p>
            </BigShipperWrapper>
        );
    }
}
